import CheckoutItemsDetail from "./CheckoutItemsDetail";

export default CheckoutItemsDetail;
